import {
  NO,
  getPhoneValue,
  getYesNoValue,
  getTrackerAgreement,
  getLastNameValue,
  getFirstNameValue,
  getYesNoValueProxy,
  getOneFromMultiProxy,
  getDateValueProxy,
  arrayIncludesKeyAndValueProxy,
  getCountryCode,
  getSpecialLicenseNumber,
  stripSpacesFromIban,
  getSalutationValue,
} from '../claimData.helpers';
import { claimsKeys, getCarMapKey } from '../../../helpers/formData/formData';
import { animalDamages, typeOfDrivers } from '../../../helpers/formData/vehicleFormData';

export default {
  'animal-damage_kind-of-damage': {
    kindOfDamage: [
      claimsKeys.KIND_OF_DAMAGE,
      getOneFromMultiProxy({
        yes: animalDamages.WILD_ANIMALS,
        no: animalDamages.OTHER_ANIMALS,
        bit: animalDamages.BITE,
      }),
    ],
    kindOfDamageShort: [
      claimsKeys.ANIMAL_DAMAGE_KIND,
      getOneFromMultiProxy({
        yes: 'j',
        no: 'n',
        bit: 'Tierbiss',
      }),
    ],
  },
  'animal-damage_day': {
    date: [claimsKeys.DATE, getDateValueProxy],
  },
  'animal-damage_location': {
    location: claimsKeys.LOCATION,
    country: [claimsKeys.COUNTRY_CODE, getCountryCode],
  },
  'animal-damage_is-ready-for-driving': [claimsKeys.IS_READY_FOR_DRIVING, getYesNoValue],
  'animal-damage_airbags-were-deployed': [claimsKeys.AIRBAGS_WERE_DEPLOYED, getYesNoValue],
  'animal-damage_warning-lights-activated': [claimsKeys.WARNING_LIGHTS_ACTIVATED, getYesNoValue],
  'animal-damage_fluids-lost': [claimsKeys.FLUIDS_LOST, getYesNoValue],
  'animal-damage_details_car-map': {
    describeDamage: claimsKeys.owner.DESCRIBE_DAMAGE,
    'front-left': [getCarMapKey('front-left'), arrayIncludesKeyAndValueProxy('carMap', 'front-left')],
    'front-middle': [getCarMapKey('front-middle'), arrayIncludesKeyAndValueProxy('carMap', 'front-middle')],
    'front-right': [getCarMapKey('front-right'), arrayIncludesKeyAndValueProxy('carMap', 'front-right')],
    'middle-left': [getCarMapKey('middle-left'), arrayIncludesKeyAndValueProxy('carMap', 'middle-left')],
    'middle-part': [getCarMapKey('middle-part'), arrayIncludesKeyAndValueProxy('carMap', 'middle-part')],
    'middle-right': [getCarMapKey('middle-right'), arrayIncludesKeyAndValueProxy('carMap', 'middle-right')],
    'back-left': [getCarMapKey('back-left'), arrayIncludesKeyAndValueProxy('carMap', 'back-left')],
    'back-middle': [getCarMapKey('back-middle'), arrayIncludesKeyAndValueProxy('carMap', 'back-middle')],
    'back-right': [getCarMapKey('back-right'), arrayIncludesKeyAndValueProxy('carMap', 'back-right')],
  },
  // !Special case after prefilling data
  'vehicle-id-ergo_license-number': {
    part1: [claimsKeys.owner.LICENSE_NUMBER, getSpecialLicenseNumber],
    claimNumber: claimsKeys.POLICY_NUMBER,
  },
  'animal-damage_details_policyholder-contact': {
    who: [claimsKeys.owner.SALUTATION, getSalutationValue],
    firstName: [claimsKeys.owner.FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.owner.LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.owner.PHONE, getPhoneValue],
    email: claimsKeys.owner.EMAIL,
    agreement: [claimsKeys.owner.TRACKER_AGREEMENT, getTrackerAgreement],
  },
  'animal-damage_driver': [
    claimsKeys.DRIVER,
    getOneFromMultiProxy({
      yes: typeOfDrivers.OWNER,
      no: typeOfDrivers.OTHER,
    }),
  ],
  'animal-damage_driver-not-policyholder': {
    firstName: [claimsKeys.thirdParty.DRIVER_FIRST_NAME, getFirstNameValue],
    lastName: [claimsKeys.thirdParty.DRIVER_LAST_NAME, getLastNameValue],
    phoneNumber: [claimsKeys.thirdParty.DRIVER_PHONE, getPhoneValue],
  },
  'animal-damage_wild-forest-report_was-reported': [claimsKeys.WAS_REPORTED, getYesNoValue],
  'animal-damage_wild-forest-report_police-report-optional_is-reported': [claimsKeys.POLICE, getYesNoValue],
  'animal-damage_wild-forest-report_police-report-optional_report-details': {
    department: claimsKeys.DEPARTMENT,
    caseNumber: claimsKeys.CASE_NUMBER,
  },
  // ToDo: Check this url!!!
  'animal-damage_police-report-optional_report-details': {
    department: claimsKeys.DEPARTMENT,
    caseNumber: claimsKeys.CASE_NUMBER,
  },
  'animal-damage_animal-repair_private-vehicle': [claimsKeys.PRIVATE_VEHICLE, getYesNoValueProxy(NO)],
  'animal-damage_animal-repair_is-repaired': [claimsKeys.IS_REPAIRED, getYesNoValue],
  'animal-damage_animal-repair_customer-services_use-kva-service': [claimsKeys.USE_KVA_SERVICE, getYesNoValue],
  'animal-damage_animal-repair_customer-services_select-workshop': {
    name: claimsKeys.KVA_SERVICE_WORKSHOP_NAME,
    address: claimsKeys.KVA_SERVICE_WORKSHOP_ADDRESS,
    city: claimsKeys.KVA_SERVICE_WORKSHOP_CITY,
    postalcode: claimsKeys.KVA_SERVICE_WORKSHOP_PLZ,
  },
  'animal-damage_animal-repair_repaired-beneficiary-iban_payment': [
    claimsKeys.BANK_ACCOUNT,
    getOneFromMultiProxy({
      'my-account': claimsKeys.MY_ACCOUNT,
      'another-account': claimsKeys.ANOTHER_ACCOUNT,
    }),
  ],
  'animal-damage_animal-repair_repaired-beneficiary-iban_name': {
    name: claimsKeys.IBAN_NAME,
    iban: [claimsKeys.IBAN, stripSpacesFromIban],
  },
  'animal-damage_animal-repair_have-you-invoices': [claimsKeys.INVOICES, getYesNoValue],
  'animal-damage_animal-repair_repaired-repair-shop': {
    name: claimsKeys.REPAIR_SHOP_NAME,
    phoneNumber: [claimsKeys.WORKSHOP_PHONE, getPhoneValue],
    city: claimsKeys.WORKSHOP_CITY,
  },
  'animal-damage_animal-repair_want-to-repair': [
    claimsKeys.DAMAGE_REPAIR,
    getOneFromMultiProxy({
      yes: claimsKeys.REPAIR,
      no: claimsKeys.PAYOUT,
    }),
  ],
  'animal-damage_details_damaged-parts': claimsKeys.DAMAGED_PARTS,
  'animal-damage_animal-repair_use-calculation-app': [claimsKeys.USE_CALCULATION_APP, getYesNoValue],
  'animal-damage_vehicle-type': [claimsKeys.VEHICLE_TYPE, getOneFromMultiProxy({
    car: claimsKeys.vehicleType.CAR,
    truck: claimsKeys.vehicleType.TRUCK,
    motorcycle: claimsKeys.vehicleType.MOTORCYCLE,
    other: claimsKeys.vehicleType.OTHER,
  })],
  'animal-damage_animal-repair_not-repaired-beneficiary-iban_payment': [
    claimsKeys.BANK_ACCOUNT,
    getOneFromMultiProxy({
      'my-account': claimsKeys.MY_ACCOUNT,
      'another-account': claimsKeys.ANOTHER_ACCOUNT,
    }),
  ],
  'animal-damage_animal-repair_not-repaired-beneficiary-iban_name': {
    name: claimsKeys.IBAN_NAME,
    iban: [claimsKeys.IBAN, stripSpacesFromIban],
  },
  'animal-damage_animal-repair_want-to-recommend-repair-shop': [claimsKeys.RECOMMEND_REPAIR_SHOP, getYesNoValue],
  'animal-damage_animal-repair_not-repaired-repair-shop': {
    name: claimsKeys.REPAIR_SHOP_NAME,
    phoneNumber: [claimsKeys.WORKSHOP_PHONE, getPhoneValue],
    city: claimsKeys.WORKSHOP_CITY,
  },
  'animal-damage_animal-repair_is-vehicle-in-workshop': [claimsKeys.WORKSHOP, getYesNoValue],
  'animal-damage_animal-repair_postal-code': claimsKeys.WORKSHOP_POSTAL_CODE,
  'animal-damage_animal-repair_select-workshop': {
    name: claimsKeys.REPAIR_SHOP_NAME,
    address: claimsKeys.WORKSHOP_ADDRESS,
    phone: claimsKeys.WORKSHOP_PHONE,
    city: claimsKeys.WORKSHOP_CITY,
    postalcode: claimsKeys.WORKSHOP_POSTAL_CODE,
    wspid: claimsKeys.WSPID_WORKSHOP,
  },
};
